export type DGESportsResponse = {
  name: string
  id: number
  color: string
  properties: {
    name: string
    id: number
  }[]
}[]

export type LicenseProperty = {
  label: string
  value: string | number
  sport?: string
}

export type LicensesContent = {
  name: string
  sportId: number
  id: number
  logoUrl: string | null
  eventCount: number
  licenseId: number | null
  licenseMaxEvents: number
  live: boolean
  tournamentCount: number
}[]

export type LicenseProperties = LicenseProperty[]

export const formatDGELicenseProperties = (
  sports: DGESportsResponse,
  licenseProperties: LicensesContent
): LicenseProperties => {
  return licenseProperties.map((property) => ({
    label: property.name,
    value: property.id,
    sport: sports.find((sport) => sport.id === property.sportId)?.name
  }))
}
